import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemNutritionNotice = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <BodyText sizeMatch={['12', '14']} style={styles.text}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    alignSelf: 'stretch',
    color: theme.colors.CHARCOAL,
    width: '100%',
  },
});
